import "./Home.css"
import hammerImg from "../../images/newHammer.png"
import hammerTransparent from "../../images/hammerTransparent.png"
import Contact from "../contact/Contact"
import About from "../about/About"
import Services from "../servicespage/Services"
import { useEffect } from "react"
import AOS from "aos"
import "aos/dist/aos.css";
import { Link } from "react-router-dom";

export default function Home() {
    useEffect(() => {
        AOS.init({ duration: 2000 })
    }, [])
    return (
        <div>
        <div className="mainHome" data-aos="fade-up" >
            <div className="homeText">
                <p className="homeHead">AHS Legal Services</p>
                
                <Link exact to="/contact">
                    <button className="btn" data-aos="fade-up">CONTACT DETAILS</button>
                </Link>
                <Link to="/services">
                    <button className="btn" data-aos="fade-up">SERVICES OFFERED</button>
                </Link>
                <Link to="/location">
                    <button className="btn" data-aos="fade-up">OFFICE LOCATION</button>
                </Link>
            </div>
            <div className="imgDiv">
                <img src={hammerImg} className="hammerImg" />

            </div>
        </div>
<About />
<Services />
<Contact />
        </div>
    )
}